import React from 'react';
import { DateOverrideIndicator } from '../../job-indicators';

export default function DateOverrideBadge() {
  // We'll reuse the DateOverrideIndicator from job-indicators.js
  return <DateOverrideIndicator />;
} 